import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { BaseComponent, UserService, EventBusService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { format, getDaysInMonth, set } from "date-fns";

@Component({
  selector: "myp-date-picker",
  templateUrl: "date-picker.component.html",
  standalone: false,
})
export class DatePickerComponent extends BaseComponent implements OnInit {
  public years: Array<string> = [];
  public months: Array<string> = ["January", "February", "March", "April", "May", "June", "July ", "August", "September", "October", "November", "December"];
  public days: Array<string> = [];

  @Input() initWithDate: Date = new Date();
  @Input() earliestYear: number = 1969;
  @Input() latestYear: number;
  @Input() includeTimePicker: boolean = false;
  public hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  // every 5 minutes
  public minutes = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];
  public selectedHour: any = "9";
  public selectedMinute: any = "00";
  public selectedAmPm: any = "am";
  public selectedYear: string = new Date().getFullYear().toString();
  public selectedMonth: string = this.months[new Date().getMonth()];
  public selectedDay: string = new Date().getDate().toString();

  public prettySelectedDate: string;
  private _selectedDate: Date;
  set selectedDate(date) {
    if (date) {
      this.prettySelectedDate = format(date, "MMMM do yyyy");
      this._selectedDate = date;
    }
  }

  get selectedDate() {
    return this._selectedDate;
  }

  @Input() public past: boolean = true;
  @Output() dateSelected: EventEmitter<any> = new EventEmitter();

  constructor(
    userService: UserService,
    private _eventBus: EventBusService,
    public activeModal: NgbActiveModal
  ) {
    super(userService);
  }

  ngOnInit() {
    const dateToUse = this.initWithDate || new Date();
    this.selectedYear = dateToUse.getFullYear().toString();
    this.selectedMonth = this.months[dateToUse.getMonth()];
    this.selectedDay = dateToUse.getDate().toString();
    for (let i = this.earliestYear; i < (this.past ? (this.latestYear ? this.latestYear : new Date().getFullYear() + 1) : 2030); i++) {
      this.years.push(i.toString());
    }
    this.years.reverse();
    this.populateDays(parseInt(this.selectedYear), this.months.indexOf(this.selectedMonth));

    // Create date in local time first
    const localDate = new Date(
      parseInt(this.selectedYear),
      this.months.indexOf(this.selectedMonth),
      parseInt(this.selectedDay),
      this.selectedAmPm === "pm" ? parseInt(this.selectedHour) + 12 : parseInt(this.selectedHour),
      parseInt(this.selectedMinute),
      0
    );

    // Then convert to UTC for storage
    this.selectedDate = new Date(Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate(), localDate.getUTCHours(), localDate.getUTCMinutes(), 0));
  }

  select(value, type) {
    if (type == "year") {
      this.selectedYear = value;
      this.populateDays(parseInt(this.selectedYear), this.months.indexOf(this.selectedMonth));
    } else if (type == "month") {
      this.selectedMonth = value;
      this.populateDays(parseInt(this.selectedYear), this.months.indexOf(this.selectedMonth));
    } else if (type == "day") {
      this.selectedDay = value;
    }
    this.setDate();
  }

  setDate() {
    setTimeout(() => {
      // Create date in local time first
      const localDate = new Date(
        parseInt(this.selectedYear),
        this.months.indexOf(this.selectedMonth),
        parseInt(this.selectedDay),
        this.selectedAmPm === "pm" ? parseInt(this.selectedHour) + 12 : parseInt(this.selectedHour),
        parseInt(this.selectedMinute),
        0
      );

      // Then convert to UTC for storage
      this.selectedDate = new Date(Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate(), localDate.getUTCHours(), localDate.getUTCMinutes(), 0));
    }, 10);
  }

  done() {
    this.dateSelected.next(this.selectedDate);
    this.close();
  }

  populateDays(year: number, month: number) {
    this.days = [];
    if (!year) year = new Date().getFullYear();
    if (!month && month !== 0) month = new Date().getMonth() + 1;
    const date = new Date(year, month, 1);
    const numberOfDays = getDaysInMonth(date);
    this.days = [];
    for (let i = 1; i <= numberOfDays; i++) {
      this.days.push(i.toString());
    }
  }

  close(event?) {
    if (event) event.stopPropagation();
    this.activeModal.close();
  }
}
